export type Customer = {
    id: string;
    name: string;
    organizationNo: string;
    address: string;
    zipCode: string;
    city: string;
    country: string;
    responsibleId?: string;
    responsible: string;
    numberOfAgreements: number;
    created: string;
    createdBy: string;
    isDeletable: boolean;
};
